"use client";

import { useState } from "react";

export default function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage("");
    setError("");

    // ✅ Validate email required
    if (!email.trim()) {
      setError("Email is required.");
      return;
    }

    // ✅ Optional: validate email format
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setError("Please enter a valid email address.");
      return;
    }
     try {
      const res = await fetch("/api/auth/forget-password", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();
      if (res.ok) {
        setMessage(data.message || "Check your email for reset instructions.");
      } else {
        setError(data.error || "Something went wrong. Please try again.");
      }
    } catch {
      setError("Failed to send request. Please try again later.");
    }
  };

  return (  
    <section className="bg-slate-50 flex items-center justify-center min-h-screen py-10 md:py-16 px-4">
      <div className="w-full max-w-lg mx-auto p-6 md:p-12 bg-white rounded-2xl border border-gray-200 shadow-lg">
        
        {/* 1. Header */}
        <div className="text-center mb-6 md:mb-10">
          <h1 className="text-xl md:text-2xl font-semibold text-slate-800">
            Forgot Password
          </h1>
          <p className="mt-1 md:mt-2 text-xs md:text-sm text-slate-600">
            Enter your email below
          </p>
        </div>
        
        {/* 2. Form */}
        <form onSubmit={handleSubmit} className="space-y-5 md:space-y-6">
          
          {/* Email Input */}
          <div>
            <label htmlFor="email" className="block text-sm md:text-base font-medium text-slate-700 mb-1 md:mb-2">
              Email
            </label>
            <input
              id="email"
              type="text"
              placeholder="Enter your email"
              className={`w-full px-4 py-2 md:py-3 bg-white rounded-lg focus:ring-0 placeholder:text-gray-400 placeholder:text-sm md:placeholder:text-base focus:outline-none text-slate-800 border text-sm md:text-base ${
                error ? "border-red-500" : "border-gray-200"
              }`}
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              suppressHydrationWarning
            />
            {error && <p className="text-red-600 text-xs md:text-sm mt-1">{error}</p>}
          </div>
          
          {/* Submit Button */}
          <div>
            <button
              type="submit"
              className="w-full bg-[#1e2d4d] text-white font-semibold py-2.5 md:py-3 px-6 rounded-lg transition-colors duration-200 hover:bg-indigo-700 text-sm md:text-base hover:cursor-pointer"
              suppressHydrationWarning
            >
              Send Reset Link
            </button>
          </div>
        </form>

        {/* Sign In Link */}
        <div className="text-center mt-4">
          <p className="text-xs md:text-sm text-slate-600">
            Remembered your password?{" "}
            <a href="/login" className="text-indigo-700 hover:underline font-semibold hover:cursor-pointer">
              Sign In
            </a>
          </p>
        </div>

        {/* Success Message */}
        {message && <p className="text-green-500 mt-4 text-center text-xs md:text-sm">{message}</p>}        

      </div>
    </section>
  );
}
